riot.tag2('gb-product-info', '<a href="{_scope.link()}"> <p class="gb-product__title">{_scope.productMeta().title}</p> <p class="gb-product__price">{_scope.productMeta().price}</p> </a>', '', '', function(opts) {
    this._scopeTo('gb-product');
});



/** WEBPACK FOOTER **
 ** ./src/tags/product/gb-product-info.tag.html
 **/